import PrimaryCell from "../../../../../../ui/Table/Cells/PrimaryCell";
import RequestDateCell from "./RequestDateCell";
import OrgRoleCell from "./OrgRoleCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 75
  },
  {
    dataField: "number",
    caption: "№ заявки",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 80
  },
  {
    dataField: "date",
    caption: "Дата заявки",
    dataType: "string",
    cellRender: RequestDateCell,
    width: 100
  },
  {
    dataField: "typeName",
    caption: "Запрос",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "name",
    caption: "Наименование",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "contractor",
    caption: "Роль в системе",
    dataType: "string",
    cellRender: OrgRoleCell
  },
  {
    dataField: "regionName",
    caption: "Регион",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "municipalName",
    caption: "МО",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "statusName",
    caption: "Статус",
    dataType: "string",
    cellRender: PrimaryCell
  }
];
